var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-fixed tw-top-0 tw-left-0 tw-z-10 tw-h-full tw-w-full tw-bg-black tw-opacity-[.45]",attrs:{"data-test-id":"overlay-global"}})}
var staticRenderFns = []

export { render, staticRenderFns }